export const SECTION_ACL_OBJECTS = [
    'SectionNew',
    'SectionList',
    'SectionDetailComponent'
];
